import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=69b7b0a3&scoped=true"
import script from "./home2.vue?vue&type=script&lang=js"
export * from "./home2.vue?vue&type=script&lang=js"
import style0 from "./home2.vue?vue&type=style&index=0&id=69b7b0a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7b0a3",
  null
  
)

export default component.exports